import { useEffect, useState } from 'react'

/**
 * Ticks once per second while `until` (epoch ms) is in the future.
 * Returns the remaining milliseconds, clamped to 0. Returns 0 (and does
 * not tick) when `until` is null or already past — so a lockout banner
 * driven by this hook disappears on its own when the window elapses.
 */
export function useCountdown(until: number | null): number {
  const [now, setNow] = useState(() => Date.now())
  const active = until !== null && until > now

  useEffect(() => {
    if (!active) return
    const t = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(t)
  }, [active])

  return active ? Math.max(0, until - now) : 0
}

/** 95_000ms → "01:35". Always mm:ss, zero-padded (tabular display). */
export function formatMmSs(ms: number): string {
  const totalSeconds = Math.ceil(ms / 1000)
  const m = Math.floor(totalSeconds / 60)
  const s = totalSeconds % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}
